<template>
	<div class="layout-emptytopbar">
		<button class="p-link layout-back-button">
			<span class="pi pi-angle-left"></span>
		</button>
			
		<div class="layout-topbar-title">			
			<span class="title">회원가입</span>
		</div>
	</div>
</template>

<script>
import {  ref } from '@vue/reactivity';
import TitleService from './service/TitleService'
import { onMounted, watch } from '@vue/runtime-core';
import { useRoute } from 'vue-router';

export default {
	emits: [ 'menu-toggle'],
	setup(){
		onMounted(() => {
            titleService.getTitles().then(data => titleList.value = data);
        })
		const title = ref();
		const subTitle = ref();
		const home = ref({icon: 'pi pi-home', to: '/'});
		const items = ref([]);
		const route = useRoute();
		const titleList = ref([]);
		const titleService = new TitleService(); 

		watch( 
			() => route.meta, 
			(meta) => {
					if(meta.title)
					{
						title.value = meta.title;
						subTitle.value = meta.subTitle;

						var found = items.value.find(element => element.label == meta.title);
						if(found )
						{
							items.value = items.value.filter(e=>e.label != meta.title)
							items.value.push({label:meta.title})
						}else{
							if(items.length>=3)
							{
								items.value.shift()
								items.value[2]={label:meta.title}
							}
							else{
								items.value.push({label:meta.title})
							}
						}

					}
					else{
						title.value  = "";
						subTitle.value = "";
					}					
			}
		)

		return {title,subTitle,home,items}
	}
}
</script>

<style scoped>
.layout-emptytopbar .layout-back-button span {
    font-size: 1.5em;
    color: black;
}
.layout-topbar-title{
	position: relative;
    top: -8px;
    left: 20px;
    display: inline-block;
}
.layout-topbar-title .title{
	font-size: 20px;
	vertical-align: middle;
	font-family: 'NotoSansKR-Bold';
}
.layout-menu-button{
	position: relative;
	top: -11px;
}
div.layout-topbar-breadcrumb{
	float: right;
	position: relative;
	top: -13px;

}
nav.p-breadcrumb.p-component{
	background-color: unset;
	border: 0ch;
	position: relative;
	float: right;
	margin: 0px;
	display: grid; 
	color: white ;
}
</style>